import { queryCache } from 'react-query';

import { DbFolder } from '~src/types/db';
import { loadFolders } from '~src/services/api';

/** Updates a cache folder entry across different queries */
export const updateCachedFolder = (
  /** folder id */
  id: DbFolder['id'],
  /** updates to apply */
  updates: Partial<DbFolder>,
  /** folders query parameters for partial match  */
  queryParams: Parameters<typeof loadFolders>['1'],
  /** matching options */
  queryPredicateOptions: Parameters<typeof queryCache.getQueries>['1'] = {
    active: true,
  }
) => {
  const queries = queryCache.getQueries<DbFolder[]>(
    ['folders', queryParams],
    queryPredicateOptions
  );

  queries.forEach((query) => {
    query.setData((prevFolders = []) =>
      prevFolders.map((prevFolder) =>
        // updated matching folder
        prevFolder.id !== id ? prevFolder : { ...prevFolder, ...updates }
      )
    );
  });
};
